import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'
import UserAvatar from 'view/component/user-avatar'
import { MenuOutlined } from '@ant-design/icons'
import { Grid } from 'antd'
import logo from 'img/pl-logo-purple.png'
import Menu from 'js/view/component/navbar/component/menu'
import { Button } from 'react-bootstrap'
import styles from './styles'

const Navbar = ({ user }) => {
  const { useBreakpoint } = Grid
  const { md } = useBreakpoint()
  const [open, setOpen] = useState(false)

  return (
    <div className='h-100 position-relative'>
      <div className={styles.home_nav_wrapper}>
        <a href='/home'>
          <img
            className={styles.collapsed_logo}
            src={logo}
          />
        </a>
        <div className={styles.nav_menu}>
          {!md
          ? <div className={open ? 'd-block' : 'd-none'}>
            <Menu
              menuDisplay={styles.menu_dropdown}
            />
          </div>
          : <Menu />
          }

        </div>
        <div>
          <div className={classnames(styles.nav_content_right)}>
            <Button
              className='bg-white border-0 me-2'
              onClick={() => setOpen(!open)}
            >
              <MenuOutlined
                className={`${md ? 'd-none' : 'd-flex'} ${styles.burger_icon}`}
              />
            </Button>

            <UserAvatar
              user={user}
            />

          </div>
        </div>
      </div>
    </div>
  )
}

Navbar.propTypes = {
  user: PropTypes.object
}

const mapStateToProps = (state) => ({
  user: state.auth.user
})

export default connect(mapStateToProps)(Navbar)
